import { TGetAnalyticsData } from "@api/analytics";
import { IconEye } from "@tabler/icons-react";
import { useState } from "react";
import { useDebounceValue } from "usehooks-ts";
import { SessionsExportCsv } from "./sessions-export-csv";
import { SessionsSort } from "./sessions-sort";
import { SessionsTableWrapper } from "./sessions-table-wrapper";

export const SessionsTable = ({
  overrides,
  isOwner,
}: {
  overrides: Partial<TGetAnalyticsData["params"]>;
  isOwner: boolean;
}) => {
  const [sortBy, setSortBy] = useState("reader");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounceValue(searchTerm, 500);
  return (
    <div className="tw-shadow-2xs tw-rounded-xl tw-mb-6 tw-outline tw-outline-1 tw-outline-blue/5 tw-bg-white tw-p-5">
      <span className="tw-text-base tw-flex tw-items-center tw-font-semibold tw-text-blue tw-font-sans tw-mb-4">
        <IconEye className="tw-size-4 tw-text-blue tw-mr-2" />
        Sessions
      </span>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
        <div className="tw-flex tw-items-center tw-gap-2">
          <SessionsSort
            sortBy={sortBy}
            setSortBy={setSortBy}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
          />
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          {/* <SessionsSearch
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
          /> */}
          <SessionsExportCsv overrides={overrides} />
        </div>
      </div>
      <SessionsTableWrapper
        sortBy={sortBy}
        sortDirection={sortDirection}
        searchTerm={debouncedSearchTerm}
        overrides={overrides}
        isOwner={isOwner}
      />
    </div>
  );
};
